export function buildLocationsLink({ prefix, link }) {
  return `${prefix}/${link}`.replace('/tech-support', '').replace('//', '/');
}
